import { Gender, GenderModule_toInt, AttendanceStatusModule_fromInt, AttendanceStatusModule_isSeated, EmptySeatStrategyModule_fromInt } from "../Shared/Types.js";
import { ta, t as t_1 } from "../Lang.js";
import { Arrange_showPreview, Arrange_hidePreview, Arrange_previewHeader, Arrange_noArrangements, Arrange_thumbsDown, Arrange_thumbsUp, Arrange_select, Arrange_view, Arrange_showDetails, Arrange_softViolations, Tooltip_violations, Arrange_hardViolations, Arrange_optimal, Tooltip_scoreBadge, Arrange_score, Arrange_selected, Arrange_stale, Arrange_liked, Arrange_arrangementN, Arrange_addNote, Arrange_generating, Tooltip_emptySeatStrategy, Arrange_emptySeatLabel, Solver_generate, Arrange_cancel, Arrange_ready, Arrange_validationTitle, Arrange_validationNoRules, Arrange_validationNoGenders, Arrange_validationManyEmpty, Arrange_validationNotEnoughSeats, Arrange_validationNoTables, Arrange_validationNoGuests, Enum_Emptyseat_off, Enum_Emptyseat_consolidate, Enum_Emptyseat_spread, Enum_Emptyseat_reduce } from "../Shared/Tr.js";
import { FSharpRef, Union } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { union_type, string_type } from "../fable_modules/fable-library-js.4.28.0/Reflection.js";
import { findIndex, tryFind as tryFind_1, empty as empty_1, sortBy, map, exists, indexed, isEmpty, ofArray, sumBy, filter, length } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { comparePrimitives, createObj, int32ToString } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { empty, collect, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { createElement } from "react";
import { helpTooltip, helpIcon } from "./Components.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { defaultArg, value as value_130 } from "../fable_modules/fable-library-js.4.28.0/Option.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { tryFind } from "../fable_modules/fable-library-js.4.28.0/Map.js";
import { tablePreview } from "./ArrangementDetail.js";

function emptySeatLabel(strategy) {
    const matchValue = EmptySeatStrategyModule_fromInt(strategy);
    switch (matchValue.tag) {
        case 1:
            return t_1(Enum_Emptyseat_reduce);
        case 2:
            return t_1(Enum_Emptyseat_spread);
        case 3:
            return t_1(Enum_Emptyseat_consolidate);
        default:
            return t_1(Enum_Emptyseat_off);
    }
}

export class ValidationIssue extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Blocking", "Warning"];
    }
}

export function ValidationIssue_$reflection() {
    return union_type("Client.Views.ArrangementView.ValidationIssue", [], ValidationIssue, () => [[["Item", string_type]], [["Item", string_type]]]);
}

function validate(state) {
    let tupledArg, tupledArg_1;
    const issues = [];
    const guestCount = length(filter((g) => AttendanceStatusModule_isSeated(AttendanceStatusModule_fromInt(g.AttendanceStatus)), state.Guests)) | 0;
    const totalSeats = sumBy((t) => t.Capacity, state.Tables, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }) | 0;
    if (guestCount === 0) {
        void (issues.push(new ValidationIssue(0, [t_1(Arrange_validationNoGuests)])));
    }
    if (length(state.Tables) === 0) {
        void (issues.push(new ValidationIssue(0, [t_1(Arrange_validationNoTables)])));
    }
    if ((guestCount > 0) && (length(state.Tables) > 0)) {
        if (guestCount > totalSeats) {
            void (issues.push(new ValidationIssue(0, [(tupledArg = Arrange_validationNotEnoughSeats(int32ToString(guestCount), int32ToString(totalSeats)), ta(tupledArg[0], tupledArg[1]))])));
        }
        else if (totalSeats > (guestCount * 2)) {
            void (issues.push(new ValidationIssue(1, [(tupledArg_1 = Arrange_validationManyEmpty(int32ToString(guestCount), int32ToString(totalSeats)), ta(tupledArg_1[0], tupledArg_1[1]))])));
        }
    }
    if ((guestCount > 0) && (length(filter((g_2) => (g_2.Gender !== GenderModule_toInt(new Gender(3, []))), filter((g_1) => AttendanceStatusModule_isSeated(AttendanceStatusModule_fromInt(g_1.AttendanceStatus)), state.Guests))) === 0)) {
        void (issues.push(new ValidationIssue(1, [t_1(Arrange_validationNoGenders)])));
    }
    if (length(state.Rules) === 0) {
        void (issues.push(new ValidationIssue(1, [t_1(Arrange_validationNoRules)])));
    }
    return toList(issues);
}

function validationPanel(state, hasBlockingIssues, issues, dispatch) {
    let elems_6;
    return createElement("div", createObj(ofArray([["className", "card mb-2"], (elems_6 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "flex items-center gap-sm mb-1"], (elems = [createElement("h3", {
            children: t_1(Arrange_validationTitle),
        }), helpIcon(() => {
            dispatch(new Msg(268, ["05", undefined]));
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(isEmpty(issues) ? singleton(createElement("p", {
                className: "text-sm",
                style: {
                    color: "#16a34a",
                },
                children: t_1(Arrange_ready),
            })) : singleton(createElement("ul", createObj(ofArray([["className", "validation-issues"], (elems_1 = toList(delay(() => collect((issue) => {
                const matchValue = issue;
                return (matchValue.tag === 1) ? singleton(createElement("li", {
                    className: "validation-issue validation-warning",
                    children: matchValue.fields[0],
                })) : singleton(createElement("li", {
                    className: "validation-issue validation-blocking",
                    children: matchValue.fields[0],
                }));
            }, issues))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_5;
                return singleton(createElement("div", createObj(ofArray([["className", "mt-2 flex items-center gap-md"], (elems_5 = toList(delay(() => append(state.IsArranging ? singleton(createElement("button", {
                    className: "btn btn-danger",
                    children: t_1(Arrange_cancel),
                    onClick: (_arg) => {
                        dispatch(new Msg(177, []));
                    },
                })) : singleton(createElement("button", {
                    className: "btn btn-primary",
                    children: t_1(Solver_generate),
                    disabled: hasBlockingIssues,
                    onClick: (_arg_1) => {
                        dispatch(new Msg(176, [1]));
                    },
                })), delay(() => {
                    let elems_4, elems_2, elems_3;
                    return singleton(createElement("div", createObj(ofArray([["className", "empty-seat-slider-row"], (elems_4 = [createElement("label", createObj(ofArray([["className", "weight-label text-sm"], (elems_2 = [t_1(Arrange_emptySeatLabel), helpTooltip(t_1(Tooltip_emptySeatStrategy))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["className", "weight-slider-control"], (elems_3 = [createElement("input", {
                        className: "weight-slider empty-seat-slider",
                        type: "range",
                        min: 0,
                        max: 3,
                        step: 1,
                        value: int32ToString(state.EmptySeatStrategy),
                        disabled: state.IsArranging,
                        onChange: (ev) => {
                            let matchValue_1;
                            let outArg = 0;
                            matchValue_1 = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
                                outArg = (v_1 | 0);
                            })), outArg];
                            if (matchValue_1[0]) {
                                dispatch(new Msg(182, [matchValue_1[1]]));
                            }
                        },
                    }), createElement("span", {
                        className: "weight-value",
                        children: emptySeatLabel(state.EmptySeatStrategy),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])));
}

function progressStepItem(index, currentStep, stepText) {
    let elems_1, elems;
    const isCompleted = index < currentStep;
    const isCurrent = index === currentStep;
    return createElement("li", createObj(ofArray([["className", isCompleted ? "progress-step progress-step-done" : (isCurrent ? "progress-step progress-step-current" : "progress-step progress-step-pending")], (elems_1 = [createElement("span", createObj(ofArray([["className", "progress-step-icon"], (elems = toList(delay(() => {
        if (isCompleted) {
            return singleton("✓");
        }
        else if (isCurrent) {
            return singleton(createElement("div", {
                className: "arrange-spinner-sm",
            }));
        }
        else {
            return empty();
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("span", {
        className: "progress-step-text",
        children: stepText,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function progressIndicator(state) {
    let elems_1, elems, elems_3, elems_2, elems_4;
    if (state.IsArranging && (length(state.ArrangeSteps) > 0)) {
        return createElement("div", createObj(ofArray([["className", "card mb-2"], (elems_1 = [createElement("ul", createObj(ofArray([["className", "progress-step-list"], (elems = toList(delay(() => collect((matchValue) => singleton(progressStepItem(matchValue[0], state.ArrangeStep, matchValue[1])), indexed(state.ArrangeSteps)))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }
    else if (state.IsArranging) {
        return createElement("div", createObj(ofArray([["className", "card mb-2"], (elems_3 = [createElement("div", createObj(ofArray([["className", "flex items-center gap-md"], (elems_2 = [createElement("div", {
            className: "arrange-spinner",
        }), createElement("span", {
            children: t_1(Arrange_generating),
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }
    else if (state.ArrangeStatus != null) {
        return createElement("div", createObj(ofArray([["className", "card mb-2"], (elems_4 = [createElement("span", {
            className: "text-sm",
            style: {
                color: isEmpty(state.Arrangements) ? "#dc2626" : "#16a34a",
            },
            children: value_130(state.ArrangeStatus),
        })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    }
    else {
        return defaultOf();
    }
}

function arrangementCard(index, arrangement, feedback, seatedGuestCount, dispatch) {
    let baseClass, elems_12;
    const hasThumbsDown = exists((f) => (f.Rating === -1), feedback);
    const isStale = arrangement.IsLiked && (arrangement.SeatCount !== seatedGuestCount);
    const scorePercent = ~~arrangement.Score | 0;
    const scoreClass = (scorePercent >= 80) ? "score-good" : ((scorePercent >= 50) ? "score-fair" : "score-poor");
    return createElement("div", createObj(ofArray([["className", (baseClass = (arrangement.IsSelected ? "card arrangement-card arrangement-selected" : "card arrangement-card"), arrangement.IsLiked ? (baseClass + " arrangement-card-rated-up") : (hasThumbsDown ? (baseClass + " arrangement-card-rated-down") : baseClass))], ["style", {
        cursor: "pointer",
    }], ["onClick", (_arg) => {
        if (!arrangement.IsSelected) {
            dispatch(new Msg(186, [arrangement.Id]));
        }
    }], (elems_12 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "arrangement-card-header"], (elems = toList(delay(() => {
            let matchValue, note, tupledArg;
            return append(arrangement.IsLiked ? ((matchValue = arrangement.Notes, (matchValue == null) ? singleton(createElement("input", {
                className: "arrangement-note-input arrangement-note-placeholder",
                placeholder: t_1(Arrange_addNote),
                maxLength: 60,
                onClick: (e_3) => {
                    e_3.stopPropagation();
                },
                onBlur: (e_4) => {
                    const value_24 = e_4.target.value;
                    if (value_24.trim() !== "") {
                        dispatch(new Msg(279, [arrangement.Id, value_24]));
                    }
                },
                onKeyDown: (e_5) => {
                    if (e_5.key === "Enter") {
                        const target_1 = e_5.target;
                        target_1.blur();
                    }
                },
            })) : ((note = matchValue, singleton(createElement("input", {
                className: "arrangement-note-input",
                defaultValue: note,
                maxLength: 60,
                onClick: (e) => {
                    e.stopPropagation();
                },
                onBlur: (e_1) => {
                    const value_14 = e_1.target.value;
                    if (value_14 !== note) {
                        dispatch(new Msg(279, [arrangement.Id, value_14]));
                    }
                },
                onKeyDown: (e_2) => {
                    if (e_2.key === "Enter") {
                        const target = e_2.target;
                        target.blur();
                    }
                },
            })))))) : singleton(createElement("h4", {
                children: (tupledArg = Arrange_arrangementN(int32ToString(index + 1)), ta(tupledArg[0], tupledArg[1])),
            })), delay(() => append(arrangement.IsLiked ? singleton(createElement("span", {
                className: "badge badge-liked",
                children: t_1(Arrange_liked),
            })) : empty(), delay(() => append(isStale ? singleton(createElement("span", {
                className: "badge badge-stale",
                children: t_1(Arrange_stale),
            })) : empty(), delay(() => (arrangement.IsSelected ? singleton(createElement("span", {
                className: "badge arrangement-selected-badge",
                children: t_1(Arrange_selected),
            })) : empty())))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_3, elems_1, elems_2;
            return append(singleton(createElement("div", createObj(ofArray([["className", "arrangement-score-row"], (elems_3 = [createElement("span", createObj(ofArray([["className", "text-sm text-muted"], (elems_1 = [t_1(Arrange_score), helpTooltip(t_1(Tooltip_scoreBadge))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement("div", createObj(ofArray([["className", "flex items-center gap-sm"], (elems_2 = toList(delay(() => append(singleton(createElement("span", {
                className: `arrangement-score ${scoreClass}`,
                children: `${scorePercent}/100`,
            })), delay(() => (arrangement.IsOptimal ? singleton(createElement("span", {
                className: "badge badge-optimal",
                children: t_1(Arrange_optimal),
            })) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_7, elems_5, elems_4, elems_6;
                return append(singleton(createElement("div", createObj(ofArray([["className", "arrangement-violations"], (elems_7 = [createElement("div", createObj(ofArray([["className", "arrangement-violation-row"], (elems_5 = [createElement("span", createObj(ofArray([["className", "text-sm text-muted"], (elems_4 = [t_1(Arrange_hardViolations), helpTooltip(t_1(Tooltip_violations))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("span", {
                    className: (arrangement.HardViolations > 0) ? "violation-count violation-hard" : "violation-count",
                    children: int32ToString(arrangement.HardViolations),
                })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["className", "arrangement-violation-row"], (elems_6 = [createElement("span", {
                    className: "text-sm text-muted",
                    children: t_1(Arrange_softViolations),
                }), createElement("span", {
                    className: (arrangement.SoftViolations > 0) ? "violation-count violation-soft" : "violation-count",
                    children: int32ToString(arrangement.SoftViolations),
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                    let elems_9, tupledArg_1, elems_8;
                    return append((length(arrangement.SoftPenaltyDetails) > 0) ? singleton(createElement("details", createObj(ofArray([["className", "arrangement-penalty-details"], (elems_9 = [createElement("summary", {
                        className: "text-sm text-muted penalty-details-toggle",
                        children: (tupledArg_1 = Arrange_showDetails(int32ToString(length(arrangement.SoftPenaltyDetails))), ta(tupledArg_1[0], tupledArg_1[1])),
                    }), createElement("ul", createObj(ofArray([["className", "penalty-detail-list"], (elems_8 = map((detail) => createElement("li", {
                        className: "text-sm",
                        children: detail,
                    }), arrangement.SoftPenaltyDetails), ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty(), delay(() => {
                        let elems_11;
                        return singleton(createElement("div", createObj(ofArray([["className", "arrangement-card-actions"], (elems_11 = toList(delay(() => append(singleton(createElement("button", {
                            className: "btn btn-sm btn-primary",
                            children: t_1(Arrange_view),
                            onClick: (_arg_1) => {
                                dispatch(new Msg(188, [arrangement.Id]));
                            },
                        })), delay(() => append(!arrangement.IsSelected ? singleton(createElement("button", {
                            className: "btn btn-sm btn-secondary",
                            children: t_1(Arrange_select),
                            onClick: (_arg_2) => {
                                dispatch(new Msg(186, [arrangement.Id]));
                            },
                        })) : empty(), delay(() => {
                            let elems_10;
                            return singleton(createElement("div", createObj(ofArray([["className", "feedback-buttons"], (elems_10 = [createElement("button", {
                                className: arrangement.IsLiked ? "feedback-btn active-up" : "feedback-btn",
                                title: t_1(Arrange_thumbsUp),
                                onClick: (e_6) => {
                                    e_6.stopPropagation();
                                    if (arrangement.IsLiked) {
                                        dispatch(new Msg(276, [arrangement.Id]));
                                    }
                                    else {
                                        dispatch(new Msg(275, [arrangement.Id]));
                                    }
                                },
                                children: "👍",
                            }), createElement("button", {
                                className: hasThumbsDown ? "feedback-btn active-down" : "feedback-btn",
                                title: t_1(Arrange_thumbsDown),
                                onClick: (e_7) => {
                                    e_7.stopPropagation();
                                    dispatch(new Msg(281, [arrangement.Id, -1, undefined]));
                                },
                                children: "👎",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))));
                        })))))), ["children", reactApi.Children.toArray(Array.from(elems_11))])]))));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

export function view(state, dispatch) {
    let elems_3;
    const issues = validate(state);
    const hasBlockingIssues = exists((i) => {
        if (i.tag === 0) {
            return true;
        }
        else {
            return false;
        }
    }, issues);
    return createElement("div", createObj(ofArray([["className", "arrangement-view"], (elems_3 = toList(delay(() => append(singleton(validationPanel(state, hasBlockingIssues, issues, dispatch)), delay(() => append(singleton(progressIndicator(state)), delay(() => {
        let seatedGuestCount, sortedArrangements, elems;
        return append((length(state.Arrangements) > 0) ? ((seatedGuestCount = (length(filter((g) => AttendanceStatusModule_isSeated(AttendanceStatusModule_fromInt(g.AttendanceStatus)), state.Guests)) | 0), (sortedArrangements = sortBy((a) => {
            if (a.IsLiked) {
                return 0;
            }
            else {
                return 1;
            }
        }, state.Arrangements, {
            Compare: comparePrimitives,
        }), singleton(createElement("div", createObj(ofArray([["className", "arrangement-grid"], (elems = toList(delay(() => collect((matchValue) => {
            const arr = matchValue[1];
            return singleton(arrangementCard(matchValue[0], arr, defaultArg(tryFind(arr.Id, state.ArrangementFeedback), empty_1()), seatedGuestCount, dispatch));
        }, indexed(sortedArrangements)))), ["children", reactApi.Children.toArray(Array.from(elems))])]))))))) : ((!state.IsArranging && (state.ArrangeStatus == null)) ? singleton(createElement("p", {
            className: "text-muted mt-2",
            children: t_1(Arrange_noArrangements),
        })) : empty()), delay(() => {
            let elems_2, arr_1;
            const matchValue_1 = tryFind_1((a_1) => a_1.IsSelected, state.Arrangements);
            let matchResult, arr_2;
            if (matchValue_1 != null) {
                if ((arr_1 = matchValue_1, (state.SelectedArrangementId == null) && (length(state.ArrangementAssignments) > 0))) {
                    matchResult = 0;
                    arr_2 = matchValue_1;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const arrIndex = findIndex((a_2) => (a_2.Id === arr_2.Id), state.Arrangements) | 0;
                    return singleton(createElement("div", createObj(ofArray([["className", "arrangement-preview"], (elems_2 = toList(delay(() => {
                        let elems_1, tupledArg;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "arrangement-preview-header"], (elems_1 = [createElement("h3", {
                            className: "arrangement-preview-title",
                            children: (tupledArg = Arrange_previewHeader(int32ToString(arrIndex + 1), int32ToString(~~arr_2.Score)), ta(tupledArg[0], tupledArg[1])),
                        }), createElement("button", {
                            className: "btn btn-sm btn-secondary",
                            children: state.ShowArrangementPreview ? t_1(Arrange_hidePreview) : t_1(Arrange_showPreview),
                            onClick: (_arg) => {
                                dispatch(new Msg(193, []));
                            },
                        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => (state.ShowArrangementPreview ? singleton(tablePreview(state, dispatch)) : empty())));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
                }
                default: {
                    return empty();
                }
            }
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

